package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.css.AlignSelf
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun UnderwrittenText(
    modifier: Modifier = Modifier,
    topAlign: AlignSelf = AlignSelf.Center,
    topVariant: CssStyleVariant<TextKind>? = null,
    underwriteVariant: CssStyleVariant<TextKind>? = null,
    underwrite: @Composable () -> Unit,
    content: @Composable () -> Unit,
) {
    Column(
        modifier = Modifier.then(modifier),
        verticalArrangement = Arrangement.spacedBy(Dimens.pageBodyUnderwritingGap),
    ) {
        Box(
            modifier = ExuraTextStyle.toModifier(
                ExuraBodySizeTextVariant,
                topVariant,
            )
                .alignSelf(topAlign)
        ) {
            content()
        }
        Box(
            modifier = ExuraTextStyle.toModifier(
                ExuraUnderwriteTextVariant,
                underwriteVariant,
            )
        ) {
            underwrite()
        }
    }
}
